import React, { useEffect, useState } from "react";
import "./Top.css";
import CV from "../assets/Amar-Braha-CV.pdf";

function SplitText({ text, className, delay = 0 }) {
  const chars = [...text];
  return (
    <span className={className}>
      {chars.map((char, i) => (
        <span
          key={i}
          className="split-char"
          style={{ "--char-delay": `${delay + i * 0.04}s` }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </span>
  );
}

function Top({ introDone }) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (introDone) {
      const t = setTimeout(() => setAnimate(true), 200);
      return () => clearTimeout(t);
    }
  }, [introDone]);

  return (
    <div id="top-wrapper" className={animate ? "animate" : ""}>
      <div id="Info">
        <br />
        <br />
        <div className="hero-header">
          <div className="avatar-wrapper">
            <img
              src="https://media.licdn.com/dms/image/v2/D4D03AQFSaVwzyQ16KA/profile-displayphoto-scale_400_400/B4DZsc2lmhG0Ag-/0/1765715631690?e=2147483647&v=beta&t=gm427ARqOMAycwKJejeVuoYiUnYR7WJM34DAV6swGwg"
              alt="Amar's avatar"
              className="avatar"
            />
          </div>

          <div className="hero-text">
            <h1>
              <SplitText text="Hi, I'm Amar " delay={0.1} />
              <span
                className="split-char wave-emoji"
                style={{ "--char-delay": "0.7s" }}
              >
                👋
              </span>
            </h1>
            <div className="status-row">
              <span className="status-dot">
                <span className="status-pulse" />
              </span>
              <span
                className="status-label fade-in"
                style={{ "--fade-delay": "0.8s" }}
              >
                Available for work
              </span>
            </div>
          </div>
        </div>

        <h1 className="hero-title">
          <SplitText text="Full-Stack Developer" delay={0.4} />
        </h1>

        <p className="hero-p fade-in" style={{ "--fade-delay": "0.9s" }}>
          18-year-old developer from Kosovo 🇽🇰 building modern web applications
          with React and Laravel. Passionate about creating beautiful and
          functional user experiences. Always learning new technologies and
          building cool projects.
        </p>

        <div
          className="social-links fade-in"
          style={{ "--fade-delay": "1.1s" }}
        >
          <a
            href="https://www.linkedin.com/in/amar-braha-983752355/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="social-button" style={{ "--brand": "#0a66c2" }}>
              <SocialIcon name="linkedin" />
            </button>
          </a>
          <a
            href="https://github.com/amarbraha"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="social-button" style={{ "--brand": "#e6edf3" }}>
              <SocialIcon name="github" />
            </button>
          </a>
          <a
            href="https://www.instagram.com/amar.braha/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="social-button" style={{ "--brand": "#e1306c" }}>
              <SocialIcon name="instagram" />
            </button>
          </a>
          <span className="sep">|</span>
          <a href={CV} download="AmarBraha-CV.pdf" className="cv-button">
            <span>Download CV</span>
            <svg
              className="cv-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </a>
        </div>
      </div>

      <div id="3d"></div>
    </div>
  );
}

export default Top;

function SocialIcon({ name }) {
  const paths = {
    github:
      "M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.009-.868-.013-1.703-2.782.604-3.369-1.34-3.369-1.34-.454-1.154-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0 1 12 6.836a9.59 9.59 0 0 1 2.504.337c1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z",
    linkedin:
      "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z",
    x: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.727-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z",
    instagram:
      "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z",
  };
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d={paths[name]} />
    </svg>
  );
}
